<i18n>
{
  "en": {
    "messages": {
      "error": "An authentication error has occurred. If you are not logged in with the award candidate's Instagram account or if you press \"Cancel\" on Instagram, please try again or wait for a while and then validate."
    }
  },
  "ja": {
    "messages": {
      "error": "認証エラーが発生しました。ダイレクトメッセージを受け取ったInstagramアカウントでログインしていない場合やInstagram認証画面上で「キャンセル」を押された場合は、再度やり直していただくか、しばらく待ってから認証してください。また、メール認証から30分以上が経過している場合は、メール認証から再度やり直してください。"
    }
  }
}
</i18n>

<template>
  <v-alert
    v-if="hasError"
    class="errormessage"
    :value="true"
    color="error"
    icon="warning"
    outline
  >
    {{ $t('messages.error') }}
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex';
import { Auth } from '@/api';
import TokenManager from '@/utils/TokenManager';

export default {
  data() {
    return {
      hasError: false
    };
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' })
  },
  mounted: async function() {
    try {
      const data = await Auth.instagramVerify({
        token: this.$route.query.state,
        instagramCode: this.$route.query.code
      });
      if (data.result.success === true) {
        TokenManager.set(data.result.auth.token);
        sessionStorage.setItem('isRedirectFromIg', 'true');
        window.location.href = data.data.emailSigninUrl;
      } else {
        throw new Error('result faild.');
      }
    } catch (error) {
      //エラー発生のため、エラー表示
      this.hasError = true;
    }
  }
};
</script>
<style scoped>
.errormessage {
  margin: 32px;
  width: auto;
}
</style>
